import { Plugin } from '@nuxt/types'
import { cookiesAccess } from './cookiesAccess.service'

const nuxtPlugin: Plugin = () => {
  cookiesAccess.initShow()
}

export default nuxtPlugin
